import { render, staticRenderFns } from "./ContentFeedGalleryItem.vue?vue&type=template&id=e1f9e816&scoped=true&"
import script from "./ContentFeedGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./ContentFeedGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./ContentFeedGalleryItem.vue?vue&type=style&index=0&id=e1f9e816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1f9e816",
  null
  
)

export default component.exports